import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { section } from './section.vanilla.mjs';

const ModalSection = forwardRef(
  ({ className: classNameFromProps, ...props }, ref) => {
    const className = classNames(section, classNameFromProps);
    return /* @__PURE__ */ jsx(
      StyledDiv,
      {
        "data-scope": "modal",
        "data-part": "section",
        className,
        ref,
        ...props
      }
    );
  }
);
ModalSection.toString = () => '[data-scope="modal"][data-part="section"]';
const StyledDiv = styled(Primitive.div);

export { ModalSection };
//# sourceMappingURL=Section.mjs.map
